import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractComponent} from "../../abstract.component";
import {AmountStatus} from "@model";

@Component({
  selector: 'app-my-tracey-page-header',
  templateUrl: './my-tracey-page-header.component.html',
  styleUrl: './my-tracey-page-header.component.scss',
  standalone: false
})
export class MyTraceyPageHeaderComponent extends AbstractComponent {
  @Input() key: string = 'app.common.back';
  @Input() hideDefault: boolean = false;
  @Input() backgroundColor: string = 'var(--grey-1000)';
  @Input() color: string = 'white';
  @Output() onBackCallback = new EventEmitter<void>();


  constructor() {
    super();
  }

  goBack() {
    this.onBackCallback.emit();
  }

  protected readonly AmountStatus = AmountStatus;
}
